<template>
    <ac-modal title="Access Member Account" ref="modal" @ac-modal-closed="onClosed">
        <p>
            You are about to enter this member's dashboard and will be able to take actions on their behalf.
        </p>
        <p>
            By selecting <strong>"Accept &amp; Continue,"</strong> you confirm that you are authorized to access and manage this member's account. This may include selecting or changing plans, approving payments, updating payment methods, and managing other account information.
        </p>
        <p>
            You are responsible for ensuring that all actions taken on the member's behalf are authorized by the member and appropriate for their account. Actions taken during this session <strong>are monitored and associated with your user account</strong> for security, auditing, and accountability purposes.
        </p>
        <template slot="buttons">
            <ac-button class="btn btn-red btn-sm" :action="cancel">Cancel</ac-button>
            <ac-button class="btn btn-green btn-sm" :action="accept">Accept &amp; Continue</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {impersonationHelper} from "../../../global/impersonation.js";

    export default {
        name: "MemberImpersonationAcknowledgementModal",
        data() {
            return {
                pending: null,
                resolvePrompt: null
            };
        },
        mounted() {
            impersonationHelper.setMemberAccessAcknowledgementPrompt(() => this.prompt());
        },
        beforeDestroy() {
            impersonationHelper.setMemberAccessAcknowledgementPrompt(null);
        },
        methods: {
            prompt() {
                if (this.pending) {
                    return this.pending;
                }
                this.pending = new Promise((resolve) => {
                    this.resolvePrompt = resolve;
                });
                this.$refs.modal.open();
                return this.pending;
            },
            accept() {
                this.finish(true);
                this.$refs.modal.close();
            },
            cancel() {
                this.finish(false);
                this.$refs.modal.close();
            },
            onClosed() {
                this.finish(false);
            },
            finish(accepted) {
                if (!this.resolvePrompt) {
                    return;
                }
                const resolve = this.resolvePrompt;
                this.resolvePrompt = null;
                this.pending = null;
                resolve(accepted);
            }
        }
    };
</script>

<style scoped>
    p {
        margin-bottom: 12px;
    }

    p:last-child {
        margin-bottom: 0;
    }
</style>
